import * as React from 'react';
import { Dialog } from 'components/dialog';
import { AddVacationDialogModel } from '../AddVacationModel';
import { SimpleSelect, SelectItem } from 'components/input/SimpleSelect';
import { CheckBox } from 'components/input/CheckBox';
import { DatePicker } from 'components/input/DatePicker';
import { TextField } from 'components/input/TextField';
import { Button } from '@material-ui/core';
import { AddVacationController } from '../AddVacationController';
import { Meta } from 'utils/meta';

export class AddVacationDialog extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = {
            dayPart: props.model.dayPart,
            isHalfDay: props.model.isHalfDay,
            selectedUser: props.model.selectedUser,
            description: "",
            startDate: null,
            endDate: null,
            type: "VACATION",
        }

        this.onUserChange = this.onUserChange.bind(this);
        this.onHalfDayChange = this.onHalfDayChange.bind(this);
        this.onTypeChange = this.onTypeChange.bind(this);
        this.onStartDayChange = this.onStartDayChange.bind(this);
        this.onEndDayChange = this.onEndDayChange.bind(this);
        this.onDayPartChange = this.onDayPartChange.bind(this);
        this.onDescriptionChange = this.onDescriptionChange.bind(this);

        this.onCancelClick = this.onCancelClick.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
    }

    private onUserChange(newValue: string) {
        this.setState({ selectedUser: newValue });
    }

    private onHalfDayChange(newValue: boolean) {
        this.setState({ isHalfDay: newValue, type: "VACATION" });
    }

    private onTypeChange(newValue: string) {
        this.setState({ type: newValue });
    }

    private onStartDayChange(newValue: Date) {
        this.setState({ startDate: newValue });
    }

    private onEndDayChange(newValue: Date) {
        this.setState({ endDate: newValue });
    }

    private onDayPartChange(newValue: string) {
        this.setState({ dayPart: newValue });
    }

    private onDescriptionChange(newValue: string) {
        this.setState({ description: newValue });
    }

    private onCancelClick() {
        this.props.controller.hideDialog();
    }

    private onSaveClick() {
        this.props.controller.saveVacation(this.state.selectedUser, this.state.isHalfDay, this.state.startDate, this.state.endDate, this.state.type, this.state.dayPart, this.state.description)
    }

    public render() {
        return (
            <Dialog title="Add vacation" desc="Fill the form below to record a day off!" error={this.props.model.globalError}>
                {this.props.model.isUserSelectable && (
                    <SimpleSelect label="User" defaultValue={this.state.selectedUser} infoText="The user of the vacation" error={this.props.model.selectedUserError} onChange={this.onUserChange}>
                        {this.props.model.users.map((item, index) => {
                            return <SelectItem key={"usi-" + item.id} title={item.name} value={item.id} />
                        })}
                    </SimpleSelect>
                )}

                {this.state.type == "VACATION" &&
                    <CheckBox label="Half day" checked={this.state.isHalfDay} onChange={this.onHalfDayChange} />
                }

                {!this.state.isHalfDay && (
                    <SimpleSelect label="Day off type" defaultValue="VACATION" infoText="The type of the day off" error={this.props.model.typeError} onChange={this.onTypeChange} >
                        {Meta.get().vacationTypes.map((item, index) => {
                            return <SelectItem key={"vt-" + index} title={item.name} value={item.id} />
                        })}
                    </SimpleSelect>
                )}

                <DatePicker label={this.state.isHalfDay ? "Day" : "First day"} value={this.state.startDate} error={this.props.model.startDateError} onChange={this.onStartDayChange} desc="The first day of the leave" />

                {this.state.isHalfDay != true && (
                    <DatePicker label="Last day" value={this.state.endDate} error={this.props.model.endDateError} onChange={this.onEndDayChange} desc="The last day of the leave" />
                )}

                {this.state.isHalfDay && (
                    <SimpleSelect label="Day part" defaultValue={this.state.dayPart} infoText="The part of the day" onChange={this.onDayPartChange} error={this.props.model.dayPartError}>
                        <SelectItem title="First half" value="FirstHalf" />
                        <SelectItem title="Second half" value="SecondHalf" />
                    </SimpleSelect>
                )}

                <TextField label="Description" value={this.state.description} desc="Describe your day off (optional)" onChange={this.onDescriptionChange} />

                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                    <Button color="secondary" onClick={this.onCancelClick}>Cancel</Button>
                    <Button style={{ marginLeft: '8px' }} color="primary" variant="contained" onClick={this.onSaveClick}>Save</Button>
                </div>

            </Dialog>
        );
    }

}

export interface Props {

    model: AddVacationDialogModel;
    controller: AddVacationController;

}

interface State {

    selectedUser: string;
    isHalfDay: boolean;
    startDate?: Date;
    endDate?: Date;
    dayPart: string;
    description: string;
    type: string;

}